import { Pipe, PipeTransform } from '@angular/core';

const monthNames = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

@Pipe({
  name: 'monthName',
})
export class MonthNamePipe implements PipeTransform {
  public transform(value: number): unknown {
    return monthName(value);
  }
}

export function monthName(value: number): string | number {
  if (monthNames[value]) {
    return monthNames[value];
  }
  return value;
}
